














































































import DashboardItems from '@/navigation/dashboard'
import appleAppStore from '@/assets/app-store-logos/download-on-the-app-store-apple.svg'
import googlePlayStore from '@/assets/app-store-logos/google-play-download-android-app.svg'
import packageJson from '../../package.json'
import { portalState } from '@/state'

interface DashboardItem {
  icons: {
    menu: string;
    dashboard: string;
  };
  title: string;
  componentName: string;
  permission: string;
  button: {
    text: string;
    url: {
      name: string;
    };
  };
}

export default {
  name: 'Dashboard',
  data: () => ({
    items: DashboardItems as DashboardItem[],
    showVelofolliesNotice: false
  }),
  computed: {
    user () {
      return portalState.user
    },
    // ...mapState(['user']),
    version: (): string => {
      const version = document.querySelector('meta[name="version"]')?.getAttribute('content') ?? packageJson.version
      return version === '{{version}}' ? packageJson.version : version
    },
    hasTiles (): boolean {
      return this.user?.role !== 'User' || false
    },
    appStore (): string {
      return appleAppStore
    },
    playStore (): string {
      return googlePlayStore
    },
    userName (): string {
      return this.user
          ? `${this.user.first_name} ${this.user.last_name}`
          : ''
    },
    permittedItems (): DashboardItem[] {
      return this.items
          .filter((item: DashboardItem) => this.hasPermission(item.permission))
    }
  },
  mounted () {
    const canShow = new Date() < new Date('2023-01-23')
    if (canShow) {
      this.showVelofolliesNotice = true
    }
  }
}
